export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const SITE = {
  company: "JOELL Asphalt Service & Maintenance Ltd.",
  shortName: "JOELL",
  tagline: "ASPHALT SERVICE • MAINTENANCE",
  slogan: "Say What You Mean, Mean What You Say!",
  director: "Eston E Joell",
  phone: "441-777-0584",
  phoneHref: "tel:+14417770584",
  phone2: "441-535-0584",
  phone2Href: "tel:+14415350584",
  whatsapp: "https://wa.me/14417770584",
  email: "ashjoell90@gmail.com",
  website: "www.joellasphaltservice.com",
  instagram: "https://www.instagram.com/joellasphaltservice/",
  facebook: "https://www.facebook.com/joellasphaltservice/",
  hours: [
    { days: "Monday – Friday", time: "7:00 AM – 6:00 PM" },
    { days: "Saturday", time: "7:00 AM – 4:00 PM" },
    { days: "Sunday", time: "Closed — emergencies by phone" },
  ],
};

export const NAV = [
  { label: "Home", to: "/" },
  { label: "Asphalt Services", to: "/asphalt-services" },
  { label: "Construction Services", to: "/construction-services" },
  { label: "Maintenance", to: "/maintenance" },
  { label: "Our Work", to: "/our-work" },
  { label: "Careers", to: "/careers" },
  { label: "News", to: "/news" },
  { label: "About", to: "/about" },
  { label: "Contact", to: "/contact" },
];

export const PARISHES = [
  "Sandys", "Southampton", "Warwick", "Paget", "Pembroke",
  "Devonshire", "Smith's", "Hamilton", "St. George's", "Other / Not sure",
];

export const QUOTE_SERVICES = [
  "Asphalt Paving & Repair",
  "Pothole Repairs",
  "Construction Services",
  "Demolition",
  "Refurbishment",
  "Trucking & Haulage",
  "Property Maintenance",
  "Other",
];

export const GALLERY_CATEGORIES = [
  "All",
  "Asphalt",
  "Construction",
  "Demolition",
  "Repairs",
  "Property Maintenance",
];

export const waLink = (text) => `${SITE.whatsapp}?text=${encodeURIComponent(text)}`;

export const SLOGAN = "Say What You Mean, Mean What You Say!";

export const WORKMANSHIP = [
  "Experienced Workmanship",
  "Clean Edges",
  "Careful Preparation",
  "Quality Finishing",
  "Pride in Every Job",
];

export const gallerySrc = (item, which = "image") => {
  if (which === "before") return item.before_path ? `${API}/files/${item.before_path}` : item.before_url;
  if (which === "after") return item.after_path ? `${API}/files/${item.after_path}` : item.after_url;
  if (item.is_album) return item.album_paths?.length ? `${API}/files/${item.album_paths[0]}` : "";
  return item.image_path ? `${API}/files/${item.image_path}` : item.image_url;
};

export const videoSrc = (item) => (item.video_path ? `${API}/files/${item.video_path}` : "");
